export default __webpack_public_path__ + "static/media/1038.6316113e.png";